// Globally unique key in window
const sharedCacheKey = Symbol("sharedCache")

declare global {
  interface Window {
    [sharedCacheKey]?: SharedCacheService
  }
}

export interface SharedCacheService {
  getOrCompute<T>(key: PropertyKey, compute: () => T): T

  remove(key: PropertyKey): boolean
}

export function useSharedCache(): SharedCacheService {
  const existing = window[sharedCacheKey]
  if (existing) {
    return existing
  } else {
    const service = createSharedCache()
    window[sharedCacheKey] = service
    return service
  }
}

function createSharedCache(): SharedCacheService {
  const cache = new Map<PropertyKey, unknown>()

  return {
    getOrCompute<T>(key: PropertyKey, compute: () => T): T {
      if (cache.has(key)) {
        return cache.get(key) as T
      }
      const value = compute()
      cache.set(key, value)
      return value
    },
    remove(key: PropertyKey): boolean {
      return cache.delete(key);
    }
  }
}


